module.exports = __webpack_public_path__ + "assets/images/9f3afb15d64067fce178735b3768f788.webp";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/backtable-urology.webp
// module id = 416
// module chunks = 0